import { UmbracoTypes } from '~/lib/data-contract';
import { Accordion, AccordionItem } from '~/shared/components/Accordion';
import { RawHtml } from '~/shared/components/RawHtml';
import { weakKey } from '~/shared/utils/jsx';
import { ModuleContainer } from '../../shared/ModuleContainer';
import { ModuleHeader } from '../../shared/ModuleHeader';

type M120Props = UmbracoTypes.IM120AccordionListModule;

export const M120Accordion = ({ headline, accordionItems = [], ...rest }: M120Props) => {
    return (
        <ModuleContainer hasGutter {...rest}>
            <ModuleHeader headlineText={headline} headlineVariant="display4" />
            <Accordion>
                {accordionItems.map((item, index) => (
                    <AccordionItem
                        id={index.toString()}
                        header={item.headline}
                        key={weakKey(item)}
                        initAsOpen={item.open}
                    >
                        <RawHtml html={item.description} />
                    </AccordionItem>
                ))}
            </Accordion>
        </ModuleContainer>
    );
};
